// Shared shape + localStorage helpers for the S10 Filters tab. Lives
// outside the tab files because the Activity tab consumes the result
// for its row predicate.
import type { InboxItem } from '@/mocks/fixtures';

export type S10Filters = {
  unreadOnly: boolean;
  kinds: InboxItem['kind'][];
};

export const DEFAULT_S10_FILTERS: S10Filters = {
  unreadOnly: false,
  kinds: [],
};

export const S10_FILTERS_LS_KEY = 'pdm.s10.filters';

export function loadS10Filters(): S10Filters {
  if (typeof window === 'undefined') return DEFAULT_S10_FILTERS;
  try {
    const raw = window.localStorage.getItem(S10_FILTERS_LS_KEY);
    if (!raw) return DEFAULT_S10_FILTERS;
    const parsed = JSON.parse(raw) as Partial<S10Filters>;
    return {
      unreadOnly: !!parsed.unreadOnly,
      kinds: Array.isArray(parsed.kinds)
        ? (parsed.kinds.filter((k): k is InboxItem['kind'] =>
            ['alert', 'mention', 'subscription'].includes(k),
          ))
        : [],
    };
  } catch {
    return DEFAULT_S10_FILTERS;
  }
}

export function saveS10Filters(filters: S10Filters) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(S10_FILTERS_LS_KEY, JSON.stringify(filters));
  } catch {
    // swallow quota errors
  }
}
